import { trendingTopics } from '@/mocks';

export default function TrendingSection() {
  const formatHeat = (heat: number) => {
    if (heat >= 10000) {
      return `${(heat / 10000).toFixed(1)}万`;
    }
    return heat.toString();
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 md:gap-8 mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
              吃瓜热榜
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-2">
              实时追踪全网最热门的爆料事件
            </p>
          </div>
          <div className="md:text-right md:pt-1">
            <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full">
              数据实时更新中
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {trendingTopics.map((topic, index) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 p-3 md:p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg text-xs md:text-sm font-bold flex-shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-700 transition-colors">
                  {topic.title}
                </p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">
                    热度 {formatHeat(topic.heat)}
                  </span>
                  {topic.trend === 'up' && (
                    <span className="text-xs text-primary-500 flex items-center gap-0.5">
                      <i className="ri-arrow-up-line" /> 上升
                    </span>
                  )}
                  {topic.trend === 'down' && (
                    <span className="text-xs text-foreground-400 flex items-center gap-0.5">
                      <i className="ri-arrow-down-line" /> 下降
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}